import React, { useEffect } from "react";

import styles from "~/styles/styles.css?url";
import toastStyles from "react-toastify/dist/ReactToastify.css?url";
import flags from "flag-icons/css/flag-icons.min.css?url";

import { type LinksFunction, type LoaderFunction } from "react-router";
import {
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useLoaderData,
	useRouteError,
} from "react-router";
import { getToast, unstable_toastMiddleware } from "remix-toast/middleware";
// DEV
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ToastContainer, toast as notify } from "react-toastify";
import NavBar from "./components/NavBar";
import { User } from "./types/generated/proto/db/models/User";
import AuthRequestUtil from "./services/auth/AuthUtil";
import ErrorPage from "./error";
import { ToastMessage } from "remix-toast";

type LoaderData = {
	toast: ToastMessage | null,
	user: User
};

export function meta() {
	return [
		{ name: "charset", content: "utf-8" },
		{ name: "title", content: "Lab" },
		{ name: "viewport", content: "width=device-width,initial-scale=1" }
	];
}

export const links: LinksFunction = () => {
	return [
		{ rel: "stylesheet", href: styles },
		{ rel: "stylesheet", href: "https://cdnjs.cloudflare.com/ajax/libs/remixicon/4.6.0/remixicon.min.css" },
		{ rel: "stylesheet", href: toastStyles },
		{ rel: "stylesheet", href: flags }
	];
};

export const unstable_middleware = [unstable_toastMiddleware()];

export const loader: LoaderFunction = async ({ request, context }) => {
	const toast = getToast(context);
	const { auth_json, user } = await AuthRequestUtil.validateRequest(request, context, false);
	return auth_json<LoaderData>({ toast, user });
};

export function ErrorBoundary() {
	const error = useRouteError() as { message: string, data: string };
	if (error.message === "NetworkError when attempting to fetch resource.") {
		return;
	}
	const date = (new Date()).toISOString();
	return ErrorPage({ message: error.message || error.data || "Unbekannter Fehler", date });
}

export default function App() {
	const { toast, user } = useLoaderData() as LoaderData;

	useEffect(() => {
		if (toast) {
			// https://github.com/forge42dev/remix-toast/issues/13
			notify(toast.message, { type: toast.type });
		}
	}, [toast]);

	return (
		<html lang="de" className="cs-no-scrolling cs-no-selection">
			<head>
				<Meta />
				<Links />
			</head>
			<body className="cs-no-scrolling">
				<NavBar user={user} />
				<Outlet />
				<ScrollRestoration />
				<Scripts />
				<ToastContainer
					position="bottom-right"
				/>
			</body>
		</html>
	);
}
